import * as React from "react";
import classNames from "classnames";
import {
	WithStyles,
	Theme,
	createStyles,
	withStyles,
	ListItemSecondaryAction
} from "@material-ui/core";
import { connect } from "react-redux";

import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

import { Dispatch } from "redux";
import { StoreState } from "../../reducers/root-reducer";
import { ConnectedSheet } from "../sheet";
import { formatDate } from "../../util/date-utility";
import { Reservation } from "../../api/reservations";
import { OccupiedDay } from "../../api/occupied-days";
import { Table } from "../../api/tables";
import { ConnectedDayOccupancySummary } from "./day-occupancy-summary";
import { Area } from "../../api/areas";
import { ConnectedPreorderedMealsList } from './preordered-meals-list';

interface State {}

export interface DashboardProps {}

interface ConnectedDashboardProps extends WithStyles<typeof styles> {
	selectedDate: Date;
	areas: Area[];
	tables: Table[];
	reservations: Reservation[];
	occupiedDays: OccupiedDay[];
}

type Props = DashboardProps & ConnectedDashboardProps;

export class Dashboard extends React.Component<Props, State> {
	public state: State = {};

	public render() {
		const { classes, selectedDate, areas } = this.props;

		return (
			<ConnectedSheet maxWidth={1200} contentClass={classes.sheetContent}>
				<Typography className={classes.sectionTitle}>
					Übersicht für {formatDate(selectedDate)}
				</Typography>
				<div className={classes.cardContainer}>
					{/*
					<div
						className={classNames(
							classes.cardWrap,
							classes.cardWrapFullWidth
						)}
					>
						<ConnectedDayOccupancySummary title="Gesamt" />
						</div>
						*/}
					{areas.map((area, index) => (
						<div
							key={area.id}
							className={classNames(classes.cardWrap, {
								[classes.cardWrapLeft]: index % 2 === 0,
								[classes.cardWrapRight]: index % 2 === 1
							})}
						>
							<ConnectedDayOccupancySummary
								title={area.name}
								area={area}
							/>
						</div>
					))}
				</div>
				<Typography className={classes.sectionTitle}>
					Vorbestellte Speisen
				</Typography>
				<ConnectedPreorderedMealsList />
			</ConnectedSheet>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({
	areas: state.areas,
	selectedDate: state.date,
	tables: state.tables,
	reservations: state.reservations,
	occupiedDays: state.occupiedDays
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

const styles = (theme: Theme) =>
	createStyles({
		sectionTitle: {
			fontSize: "1.2rem",
			fontWeight: 500,
			marginBottom: 10
		},
		cardContainer: {
			display: "flex",
			flexWrap: "wrap"
		},
		cardWrap: {
			width: "50%",
			marginBottom: 15,

			[theme.breakpoints.down(767)]: {
				width: "100%",
				padding: "0 !important"
			}
		},
		cardWrapLeft: {
			paddingRight: 8
		},
		cardWrapRight: {
			paddingLeft: 8
		},
		cardWrapFullWidth: {
			width: "100%"
		},
		sheetContent: {
			padding: 2
		}
	});

export const ConnectedDashboard = withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Dashboard)
);
